export const THEODORE_LOGIN = 'THEODORE_LOGIN';
export const LOGIN_SUCCESS='LOGIN_SUCCESS';
export const LOGIN_FAILURE='LOGIN_FAILURE';
export const LOGOUT='LOGOUT';

export const login = (data) => {
    return {
        type: THEODORE_LOGIN,
        data
    }
}
export const loginSuccess = (data) => {
    return {
        type: LOGIN_SUCCESS,
        data
    }
}
export const loginFailure = (data) => {
    return {
        type: LOGIN_FAILURE,
        data
    }
}

/*export const FETCH_USER_ROLES = 'FETCH_USER_ROLES';
export const USER_ROLES_SUCCESS='USER_ROLES_SUCCESS';
export const USER_ROLES_FAILURE='USER_ROLES_FAILURE';

export const fetchUserRoles = (data) => {
    return {
        type: FETCH_USER_ROLES,
        data
    }
}
export const userRolesSuccess = (data) => {
    return {
        type: USER_ROLES_SUCCESS,
        data
    }
}
export const userRolesFailure = (data) => {
    return {
        type: USER_ROLES_FAILURE,
        data
    }
}*/

export const SET_USER_DETAILS = 'SET_USER_DETAILS';
export const  setUserDetails = (data) => {
    return {
        type: SET_USER_DETAILS,
        data
    }
}

export const logout = () => {
  return {
    type:LOGOUT
  }
}